import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { NotificationView } from '../notification-view';
import { NotificationTypeProps } from './notification-type-props';
import { useTranslations } from 'i18n';
import { parseJSON } from 'date-fns';

export const ActivityOwnership: React.FC<NotificationTypeProps> = ({ notification, handleToggleRead }) => {
    const { __ } = useTranslations();
    const names = notification.activities?.map((activity) => activity.name) ?? [];

    if (!names.length) {
        return <></>;
    }

    const bodyKey = names.length >= 5 ? '5_or_more' : names.length;

    return (
        <NotificationView
            title={
                names.length === 1
                    ? __('notifications.activity_ownership_single_title', { activityName: names[0] })
                    : __('notifications.activity_ownership_multiple_title', { numberOfActivities: `${names.length}` })
            }
            contents={
                names.length === 1 ? (
                    __('notifications.activity_ownership_single_body')
                ) : (
                    <ReactMarkdown>
                        {__(`notifications.activity_ownership_multiple_${bodyKey}_body`, {
                            activity1: names[0],
                            activity2: names[1],
                            activity3: names[2] ?? '',
                            otherCount: `${names.length - 3}`,
                        })}
                    </ReactMarkdown>
                )
            }
            createdAt={parseJSON(notification.created_at)}
            isRead={notification.read === 1}
            onToggleRead={handleToggleRead}
        />
    );
};
